import { state } from 'cerebral'
import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'oneToOneActivities' })

export const redirectAfterSave = ({ props = {}, get, path }) => {
  const { entities: { oneToOneActivities: [activity] = [] } = {} } = props

  const returnTo = get(state`route.query.returnTo`)

  if (returnTo === 'connectionBoard') {
    return path.connectionBoard()
  }

  if (returnTo === 'profile' && activity?.profile) {
    return path.profile({
      params: {
        id: activity.profile,
        tab: 'one-to-one-activities',
      },
    })
  }

  return path.list()
}
